<template>
  <div class="cat-tabs-vert">
    <div class="grid-x">
      <div class="cell large-2 large-push-10 vert-tabs">
        <ul>
          <li
            v-for="(item, idx) in items"
            :key="idx + 1"
            :class="_css(item.step)"
          >
            <a
              href="#"
              :data-button="item.title"
              @click.prevent="_onClick($event, item.step)"
              >{{ item.title }}</a
            >
          </li>
        </ul>
      </div>

      <div class="cell large-10 large-pull-2 vert-tab-content">
        <div class="vert-tab-content-padding">
          <h2 data-label-type="heading">{{ items[selected - 1].title }}</h2>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatVerticalTabs",
  inject: ["addContentClass"],
  props: {
    id: {
      type: [String, Number]
    },
    items: {
      type: [Array]
    },
    selected: [Number]
  },
  data: function () {
    return {
      sel: this.selected ? this.selected : 1
    };
  },
  watch: {
    selected: function (newsel) {
      this.sel = newsel;
    }
  },

  methods: {
    _onClick: function (event, step) {
      // console.log("Clicked on stepper", event, step);
      this.$emit("ui-click", {
        event: event,
        value: step,
        id: this.id ? this.id : null
      });
    },
    _css: function (step) {
      return {
        selected: this.selected == step,
        tab: true
      };
    }
  },
  created: function () {
    this._default = this.selected ? this.selected : this.items[0].step;
  }
});
</script>
